/* eslint-disable no-useless-escape */
export const SPECIAL_CHAR_FORMAT = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/;
export const UPPER_CASE_FORMAT = /[A-Z]/;
export const LOWER_CASE_FORMAT = /[a-z]/;
export const NUMBERS_FORMAT = /[0-9]/;
export const MIN_NUM_OF_CHAR = 8;
